import React, { useState } from 'react';
import {
  Typography,
  Box,
  Button,
  CircularProgress,
  Alert,
  Container,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MicroSiteList from '../../components/MicroSite/MicroSiteList';
import AccountLayout from '../../layouts/AccountLayout';
import { Add as AddIcon, DesignServices as DesignServicesIcon } from '@mui/icons-material';
import CreateMicroSite from '../../components/MicroSite/CreateMicroSite';
import PageBuilderDialog from '../../components/Layout/PageBuilderDialog';

function MicroSites() {
  const { accountId } = useParams();
  const [isCreateOpen, setIsCreateOpen] = React.useState(false);
  const { currentAccount, isLoading, error } = useSelector((state) => state.account);
  const [openPageBuilderDialog, setOpenPageBuilderDialog] = useState(false);

  if (isLoading) {
    return (
      <AccountLayout>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      </AccountLayout>
    );
  }

  if (error) {
    return (
      <AccountLayout>
        <Alert severity="error">{error}</Alert>
      </AccountLayout>
    );
  }

  return (
    <AccountLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            MicroSites
          </Typography>
          <Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<DesignServicesIcon />}
              onClick={() => setOpenPageBuilderDialog(true)}
              sx={{ mr: 2 }}
            >
              Page Builder
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setIsCreateOpen(true)}
            >
              Add MicroSite
            </Button>
          </Box>
        </Box>

        <MicroSiteList accountId={accountId} />

        <CreateMicroSite
          open={isCreateOpen}
          onClose={() => setIsCreateOpen(false)}
          accountId={accountId}
        />

        {/* Page Builder Dialog */}
        <PageBuilderDialog 
          open={openPageBuilderDialog} 
          onClose={() => setOpenPageBuilderDialog(false)} 
          accountId={accountId}
        />
      </Container>
    </AccountLayout>
  );
}

export default MicroSites; 